<template>
  <div class="page-wraper">
    <!-- autoSetFirstValue -->
    <dataForm
      :items="searchFormItems"
      ref="searchForm"
      class="search-form"
      :onOptionsLoadAfter="onOptionsLoadAfter"
    />
    <div class="main">
      <Calender
        :defauleMonth="currentMonth"
        :hasShowStar="hasItems"
        :switchMonthCallback="onCalenderSwitchMonth"
        @dateSelect="onDateSelect"
        style="margin-bottom: 10px"
      />

      <div
        class="bottomList"
        v-if="currentMonth == currentSelectDateInfo.Month"
      >
        <div
          class="listItem"
          v-for="(item, index) in currentSelectDateInfo.Items"
          :key="index"
          :class="index % 2 == 0 ? 'yellow-border' : 'red-border'"
        >
          <p>课程名称：{{ item.CourseName }}</p>
          <p>上课时间：{{ item.BeginTime }} - {{ item.EndTime }}</p>
          <p>预订人：{{ item.TeacherName }}</p>
          <p>班次名称：{{ item.ClassName }}</p>
          <img
            v-if="item.DisplayConfirmFlag"
            src="../../../public/image/review.png"
            alt=""
            class="review"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import classRoomApi from "@/api/classRoom.js"
import dataForm from "@/components/base/form/dataForm"
import Calender from "../components/Calender"

export default {
  components: { dataForm, Calender },
  data() {
    const that = this
    return {
      searchFormItems: [
        {
          title: "地点",
          field: "buildingCode",
          itemRender: {
            name: "a-select",
            props: {
              api: classRoomApi.QueryMeetingRoomBuildings,
              param: { FilterAccess: true },
              dataField: "Data",
              valueField: "BuildingCode",
              labelField: "Name",
              titleWidth: "80px",
            },
            on: {
              change() {
                that.$nextTick(() => {
                  that.buildingCodeChange()
                })
              },
            },
          },
        },
        {
          title: "楼层",
          field: "floorCode",
          itemRender: {
            name: "a-select",
            props: {
              // api: classRoomApi.QueryMeetingRoomBuildings,
              // param: {},
              dataField: "Data",
              valueField: "FloorCode",
              labelField: "Name",
              titleWidth: "80px",
            },
            on: {
              change() {
                that.$nextTick(() => {
                  that.floorCodeChange()
                })
              },
            },
          },
        },
        {
          title: "教室",
          field: "roomId",
          itemRender: {
            name: "a-select",
            props: {
              // api: classRoomApi.QueryMeetingRoomBuildings,
              // param: {},
              dataField: "Data",
              valueField: "RoomId",
              labelField: "Name",
              titleWidth: "80px",
            },
            on: {
              change(e) {
                that.$nextTick(() => {
                  if (e) {
                    that.roomIdChange()
                  }
                })
              },
            },
          },
        },
      ],
      currentMonth: moment().format("YYYY-MM"),
      currentSelectDateInfo: {
        Items: [],
      },
      detail: {},
      roomSchedulesByDate: {},
      searchParams: {},
    }
  },
  created() {
    // this.fetchMeetingRoomApplies();
  },
  methods: {
    hasItems(day) {
      const { roomSchedulesByDate } = this
      const date = moment(day.date).format("YYYY-MM-DD")
      if (roomSchedulesByDate[date] && roomSchedulesByDate[date].Items.length) {
        return true
      }
      return false
    },
    fetchMeetingRoomApplies(param, callback = null) {
      const { currentMonth } = this
      const json = {
        ...param,
        BeginDate: moment(currentMonth)
          .startOf("month")
          .format("YYYY-MM-DD"),
        EndDate: moment(currentMonth)
          .endOf("month")
          .format("YYYY-MM-DD"),
        FilterAccess: true,
      }
      classRoomApi.QueryMeetingRoomApplies(json).then((res) => {
        if (res.Data.length) {
          const detail = res.Data[0]
          let roomSchedulesByDate = {}
          for (let i = 0; i < detail.Schedules.length; i++) {
            const item = detail.Schedules[i]
            roomSchedulesByDate[item.Date] = item
          }
          this.roomSchedulesByDate = roomSchedulesByDate
          this.detail = detail
          if (callback) {
            callback(res)
          }
        }
      })
    },
    onCalenderSwitchMonth(date) {
      this.currentMonth = date.format("YYYY-MM")
      return new Promise((resolve) => {
        this.fetchMeetingRoomApplies(this.searchParams, (res) => {
          resolve(res)
        })
      })
    },
    onDateSelect(date) {
      const { roomSchedulesByDate } = this
      const item = roomSchedulesByDate[date]
      item.Month = moment(date).format("YYYY-MM")
      this.currentSelectDateInfo = item
    },
    onOptionsLoadAfter(value) {
      // if (value.buildingCode && value.buildingCode.length) {
      //   value.buildingCode[0].BuildingCode;
      // }
      return value
    },
    buildingCodeChange() {
      const data = this.$refs.searchForm.getData()
      if (data.buildingCode || data.buildingCode == 0) {
        classRoomApi
          .QueryMeetingRoomFloors({
            BuildingCode: data.buildingCode,
            FilterAccess: true,
          })
          .then((res) => {
            this.$refs.searchForm.setFieldsOptions({
              floorCode: res.Data,
            })
          })
      } else {
        this.$refs.searchForm.setFieldsOptions({
          floorCode: [],
        })
        this.$refs.searchForm.setFieldsOptions({
          roomId: [],
        })
        this.$refs.searchForm.setData({
          floorCode: "",
        })
        this.$refs.searchForm.setData({
          roomId: "",
        })
      }
    },
    floorCodeChange() {
      const data = this.$refs.searchForm.getData()
      if (
        (data.floorCode || data.floorCode == 0) &&
        (data.buildingCode || data.buildingCode == 0)
      ) {
        classRoomApi
          .QueryMeetingRooms({
            floorCode: data.floorCode,
            buildingCode: data.buildingCode,
            FilterAccess: true,
          })
          .then((res) => {
            this.$refs.searchForm.setFieldsOptions({
              roomId: res.Data,
            })
          })
      } else {
        this.$refs.searchForm.setFieldsOptions({
          roomId: [],
        })
        this.$refs.searchForm.setData({
          roomId: "",
        })
      }
    },
    roomIdChange() {
      this.searchParams = this.$refs.searchForm.getData()
      const that = this
      this.fetchMeetingRoomApplies(this.searchParams, () => {
        that.onDateSelect(moment().format("YYYY-MM-DD"))
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  padding: 0 15px;
  background-color: rgb(255, 255, 255);
  .item {
    position: relative;
    padding: 16px;
    border-radius: 7px;
    background-color: rgb(248, 248, 248);
    margin-bottom: 10px;
    .title {
      font-weight: 900;
      color: rgb(51, 51, 51);
    }
    .before {
      margin-top: 2px;
    }
    .date {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .selectBox {
      position: absolute;
      top: 18px;
      right: 44px;
      color: rgb(102, 102, 102);
      font-weight: 600;
      img {
        position: absolute;
        right: -30px;
        top: 0px;
      }
    }
  }
  .bottomList {
    .listItem {
      padding: 15px;
      background-color: rgb(248, 248, 248);
      color: rgb(51, 51, 51);
      margin-bottom: 10px;
      border-radius: 5px;
      letter-spacing: 0px;
      font-size: 14px;
      position: relative;
      .review {
        height: 60px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .yellow-border {
      border-top: 2px solid rgb(255, 198, 58);
    }
    .red-border {
      border-top: 2px solid rgb(210, 0, 0);
    }
    p {
      margin-bottom: 2px;
    }
    p :last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
